<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group
            label="Search"
            label-for="filter_user_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_user_search"
              v-model="tableMerchant.filter.search"
              type="text"
              size="sm"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          order="3"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="primary"
            @click="onCreateMerchant"
          >
            Add Merchant
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableMerchant"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableMerchant.perPage"
            :current-page="tableMerchant.currentPage"
            :items="tableMerchantProvider"
            :fields="tableMerchant.fields"
            :sort-by.sync="tableMerchant.sortBy"
            :sort-desc.sync="tableMerchant.sortDesc"
            :sort-direction="tableMerchant.sortDirection"
            :filter="tableMerchant.filter"
            :filter-included-fields="tableMerchant.filterOn"
            :busy="tableMerchant.busy"
          >
            <template #cell(index)="row">
              {{ tableMerchant.currentPage * tableMerchant.perPage - tableMerchant.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="onEditMerchant(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mt-2 px-1"
        >
          <b-select
            v-model="tableMerchant.perPage"
            :options="tableMerchant.pageOptions"
            size="sm"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-2 px-1"
        >
          <b-pagination
            v-model="tableMerchant.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableMerchant.totalRows"
            :per-page="tableMerchant.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-merchant"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      :title="ModalMerchantTitle"
    >
      <ValidationObserver
        ref="formMerchant"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="first name"
                vid="first_name"
                rules="required|max:50"
              >
                <b-form-group
                  label="First Name"
                  label-for="first_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="first_name"
                    v-model="merchant.first_name"
                    type="text"
                    autocomplete="off"
                    maxlength="50"
                    placeholder="enter first name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="last name"
                vid="last_name"
                rules="required|max:50"
              >
                <b-form-group
                  label="Last Name"
                  label-for="last_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="last_name"
                    v-model="merchant.last_name"
                    type="text"
                    autocomplete="off"
                    maxlength="50"
                    placeholder="enter last name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="email"
                vid="email"
                rules="email|max:50"
              >
                <b-form-group
                  label="Email"
                  label-for="email"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="email"
                    v-model="merchant.email"
                    type="email"
                    autocomplete="off"
                    maxlength="50"
                    placeholder="enter email here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="username"
                vid="username"
                rules="required|max:50"
              >
                <b-form-group
                  label="Username"
                  label-for="username"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="username"
                    v-model="merchant.username"
                    type="text"
                    autocomplete="off"
                    maxlength="50"
                    placeholder="enter username here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="password"
                vid="password"
                :rules="vPassword"
              >
                <b-form-group
                  label="Password"
                  label-for="password"
                  description="Leave blank when not changing password."
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input-group
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-input
                      id="password"
                      v-model="merchant.password"
                      autocomplete="off"
                      maxlength="50"
                      placeholder="enter password here"
                      :type="passwordType"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <b-input-group-append>
                      <b-button
                        class="pl-2 pr-1"
                        variant="primary"
                        style="border-radius: 0px 5px 5px 0px"
                        :disabled="state.busy"
                        @click="togglePasswordType"
                      >
                        <i
                          v-if="state.password_visible"
                          class="ri-eye-line h5"
                        />
                        <i
                          v-else
                          class="ri-eye-off-line h5"
                        />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="password confirmation"
                vid="password_confirmation"
                :rules="vPasswordConfirmation"
              >
                <b-form-group
                  label="Password Confirmation"
                  label-for="password_confirmation"
                  description="Leave as blank when not changing password."
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="password_confirmation"
                    v-model="merchant.password_confirmation"
                    autocomplete="off"
                    maxlength="50"
                    placeholder="enter password confirmation here"
                    :type="passwordType"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group
                class="mb-2"
              >
                <b-form-checkbox
                  id="is_active"
                  v-model="merchant.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>

          </b-row>
        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <b-button
          variant="primary"
          :disabled="state.busy"
          @click="onValidateMerchant"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SAdminMerchant } from '@/services'
import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

export default {
  name: 'AdminMerchants',

  middleware: ['auth', 'admin'],

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Merchants'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        password_visible: false
      },
      merchant: {
        id: null,
        username: null,
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
        active: 1
      },
      tableMerchant: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 9, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'username' },
          { mobile: 3, key: 'first_name' },
          { mobile: 4, key: 'last_name' },
          { mobile: 5, key: 'email' },
          { mobile: 7, key: 'active', class: 'text-center' },
          { mobile: 8, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalMerchantTitle () {
      return this.state.editing ? 'Edit Merchant' : 'Add Merchant'
    },

    vPassword () {
      return `${this.state.editing ? '' : 'required|'}min:8`
    },

    vPasswordConfirmation () {
      return `${this.state.editing ? '' : 'required|'}confirmed:password`
    },

    passwordType () {
      return this.state.password_visible ? 'text' : 'password'
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    togglePasswordType () {
      this.state.password_visible = !this.state.password_visible
    },

    async tableMerchantProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableMerchant.busy = true
      return await SAdminMerchant.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tableMerchant.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableMerchant.busy = false
      })
    },

    onCreateMerchant () {
      this.state.editing = false
      this.merchant.id = null
      this.merchant.username = null
      this.merchant.first_name = null
      this.merchant.last_name = null
      this.merchant.email = null
      this.merchant.password = null
      this.merchant.password_confirmation = null
      this.merchant.active = 1
      this.$bvModal.show('modal-merchant')
    },

    onEditMerchant (merchant) {
      this.state.editing = true
      this.merchant.id = merchant.id
      this.merchant.username = merchant.username
      this.merchant.first_name = merchant.first_name
      this.merchant.last_name = merchant.last_name
      this.merchant.email = merchant.email
      this.merchant.password = null
      this.merchant.password_confirmation = null
      this.merchant.active = merchant.active
      this.$bvModal.show('modal-merchant')
    },

    async onValidateMerchant (event) {
      event.preventDefault()
      await this.$refs.formMerchant.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your Changes on this Merchant?</h6>'
                }
                return '<h6>Create this Merchant?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutMerchant()
                }
                return this.onPostMerchant()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostMerchant () {
      return new Promise(resolve => {
        SAdminMerchant.post(this.merchant).then(
          ({ data: { message } }) => {
            this.$refs.tableMerchant.refresh()
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-merchant')
            })
            resolve(message)
          }
        ).catch(({ message }) => {
          this.$refs.formMerchant.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutMerchant () {
      return new Promise(resolve => {
        SAdminMerchant.put(this.user).then(
          ({ message, user }) => {
            const tableMerchantRow = QUERY.find(this.$refs.tableMerchant.localItems, { id: user.id })
            if (tableMerchantRow) {
              tableMerchantRow.username = user.username
              tableMerchantRow.first_name = user.first_name
              tableMerchantRow.last_name = user.last_name
              tableMerchantRow.email = user.email
              tableMerchantRow.active = user.active
              tableMerchantRow.updated_at = user.updated_at
            }
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-merchant')
            })
            resolve(user)
          }
        ).catch(({ message }) => {
          this.$refs.formMerchant.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
